module.exports = __webpack_public_path__ + "static/media/add.29e1ec2e.svg";